import RougeRewardsCarousel from 'components/RougeRewardsCarousel/RougeRewardsCarousel';
import { withRougeRewardsCarouselProps } from 'viewModel/rougeRewardsCarousel/withRougeRewardsCarouselProps';

export default withRougeRewardsCarouselProps(RougeRewardsCarousel);
